export default function AdminDaysSince({
  since,
  setSince,
}: {
  since: string;
  setSince: ({ since }: { since: string }) => void;
}) {
  return (
    <div className='mb-2'>
      <div className='flex items-center text-xs font-bold uppercase max-md:justify-center'>
        Since:
        <button
          className={`ml-4 p-1 text-xs font-bold uppercase hover:opacity-70 ${
            since == '1' ? 'underline' : ''
          }`}
          onClick={() => setSince({ since: '1' })}
        >
          1 Day
        </button>
        <button
          className={`ml-4 p-1 text-xs font-bold uppercase hover:opacity-70 ${
            since == '7' ? 'underline' : ''
          }`}
          onClick={() => setSince({ since: '7' })}
        >
          7 Days
        </button>
        <button
          className={`ml-4 p-1 text-xs font-bold uppercase hover:opacity-70 ${
            since == '30' ? 'underline' : ''
          }`}
          onClick={() => setSince({ since: '30' })}
        >
          30 Days
        </button>
        <button
          className={`ml-4 p-1 text-xs font-bold uppercase hover:opacity-70 ${
            since == '60' ? 'underline' : ''
          }`}
          onClick={() => setSince({ since: '60' })}
        >
          60 Days
        </button>
        <button
          className={`ml-4 p-1 text-xs font-bold uppercase hover:opacity-70 ${
            since == '90' ? 'underline' : ''
          }`}
          onClick={() => setSince({ since: '90' })}
        >
          90 Days
        </button>
        <button
          className={`ml-4 p-1 text-xs font-bold uppercase hover:opacity-70 ${
            since == '' ? 'underline' : ''
          }`}
          onClick={() => setSince({ since: '' })}
        >
          All
        </button>
      </div>
    </div>
  );
}
